import React from "react";
import { Link } from "react-router-dom";
import Logout from "../Layout/Logout";

function Profilesidebar(props) {
  return (
    <div className="col-xl-3 col-lg-4 m-b30">
      <div className="sticky-top">
        <div className="candidate-info">
          <div className="candidate-detail text-center">
            <div className="canditate-des">
              <img alt="" src={props.value} />
              <div
                className="upload-link"
                title="update"
                data-toggle="tooltip"
                data-placement="right"
              >
                <input
                  type="file"
                  className="update-flie"
                  onChange={props.Change}
                />
                <i className="fa fa-camera"></i>
              </div>
            </div>
            <div className="candidate-title">
              <div className="">
                <h4 className="m-b5">{props.Name}</h4>
                <p className="m-b0">{props.title}</p>
              </div>
            </div>
          </div>
          <ul>
            <li>
              <Link to={"/Profile"} className="active">
                <i className="fa fa-user-o" aria-hidden="true"></i>
                <span>Profile</span>
              </Link>
            </li>
            <li>
              <Link to={"/change-password"}>
                <i className="fa fa-key" aria-hidden="true"></i>
                <span>Change Password</span>
              </Link>
            </li>
            <li>
              <Logout />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default Profilesidebar;
